/**
 * Returns a shallow copy of the input, with applied reorderings.
 * Both "from" and "to" arguments MUST be in increasing order.
 */
export function reorder(input, from, to) {
    let copy = [...input];
    let toMove = [];
    for (let i = 0; i < from.length; i++) {
        toMove[i] = copy.splice(from[i] - i, 1)[0];
    }
    for (let i = 0; i < from.length; i++) {
        copy.splice(to[i], 0, toMove[i]);
    }
    return copy;
}
export function createSendToBackIndices(indices) {
    const c = [];
    for (let i = 0; i < indices.length; i++) {
        c[i] = i;
    }
    return c;
}
export function createMoveToFrontIndices(indices, length) {
    const c = [];
    for (let i = 0; i < indices.length; i++) {
        c[i] = length - indices.length + i;
    }
    return c;
}
export function createMoveForwardIndices(indices, length) {
    const max = indices[indices.length - 1];
    return createMoveToFrontIndices(indices, Math.min(max + 2, length));
}
export function createSendBackwardIndices(indices) {
    const min = Math.max(0, indices[0] - 1);
    const c = [];
    for (let i = 0; i < indices.length; i++) {
        c[i] = min + i;
    }
    return c;
}
